import { Component, OnInit } from '@angular/core';
import { User } from './models/user.model';
import { Storage } from '@ionic/storage-angular';
import { AccountService } from './services/account.service';
import { LanguageService } from './services/language.service';
import { interval, Subscription, timer } from 'rxjs';
import { VisitorService } from './admin/services/visitor.service';
import { VisitService } from './admin/services/visit.service';
import { map, share } from 'rxjs/operators';
import { CallHubService, IncomingCallPayload } from './admin/services/call-hub.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  loggedUser$ = this.accountService.currentUser$;
  dateTime: string;
  time = new Date();
  rxTime = new Date();
  intervalId;
  subscription: Subscription;
  private callSub?: Subscription;

  /*  */
  i: number;
  paginationSettings = { totalItems: 0 };
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  birthDateQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  roomQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  statusQuery: string = '';
  /* visits$ = this.visitService.visit$;
  visitors$ = this.visitorService.visitors$; */
  pageSize: number = 2147483647;
  /*  */

  constructor(private accountService: AccountService,
    private languageService: LanguageService,
    private storage: Storage,
    private visitService: VisitService,
    private callHub: CallHubService,
    private router: Router) {
    this.initStorage();
  }

  async initStorage() {
    await this.storage.create();
  }

  ngOnInit() {
    this.setCurrentUser();
    this.languageService.setInitialAppLanguage();

    const user = JSON.parse(localStorage.getItem('loggedUser') || 'null') as User | null;
    this.accountService.setCurrentUser(user || undefined);

    this.callSub = this.callHub.incoming$.subscribe((p: IncomingCallPayload) => {
      console.log('[CALL] event received:', p);

      if (p.evt !== 'NOTIFY_ANSWER') return;

      if (p.found && p.visitorId) {
        this.router.navigate(['admin', 'call-list']);
      }
    });
  }

  ngOnDestroy() {
    this.callSub?.unsubscribe();
  }

  setCurrentUser() {
    const user: User = JSON.parse(localStorage.getItem('loggedUser'));
    this.accountService.setCurrentUser(user);
  }
}


